import ScrollableContainer from '@/components/ScrollableContainer';
import Screen from '@/components/layout/Screen';
import { useState } from 'react';
import QuotesEditForm from './components/QuotesEditForm';
import { useParams } from 'react-router';

const QuotesEditScreen = () => {
  const [isEditMode, setisEditMode] = useState(true);
  const { id } = useParams<{ id: any }>();

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Quote',
          backBtnLabel: 'Book',
          backBtnUrl: `/books/${id}`,
        },
      }}
    >
      <ScrollableContainer className='relative'>{isEditMode ? <QuotesEditForm /> : null}</ScrollableContainer>
    </Screen>
  );
};

export default QuotesEditScreen;
